import API from "../../axiosConfig/axiosConfig"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../../components/Notification/Notifications"
import {
  SUCCESS_ITEM_ADD_TO_CART,
  SUCCESS_ITEM_REMOVE_FROM_CART,
  ERROR_SOMETHING_WENT_WRONG,
  SUCCESS_CART_CLEAR,
} from "../../constants/notificationMsg"
import {
  SUGGEST_RESTAURANT_NAME,
  ACCEPT_SUGGESTION,
  DECLINE_SUGGESTION,
  CHANGE_RESTAURANT,
  ADD_OR_REMOVE_ITEM,
  GET_RESTAURANTS,
  GET_RESTAURANT_MENU,
  WHICH_ITEMS_ARE_SUGGESTED,
  RESET_WHICH_ITEMS_ARE_SUGGESTED,
  REMOVE_ITEM_FROM_CART,
  EMPTY_DELIVERY_DOT_COM_CART,
  TOGGLE_ADD_TO_CART_POPUP,
  REMOVE_ITEM_FROM_SUGGESTED_LIST,
  GET_CART_ITEMS_FROM_DELIVERY,
  GETTING_RESTAURANTS,
  RESTAURANTS_LOADED,
  NOTIFY_SUBSCRIBED,
  SET_LOADER,
  SELECTED_ITEM_OPTIONS,
  SHOW_READY_MODAL,
  SET_LOADING_MENUS,
  SET_SUGGESTING,
  PARTNER_OPERATION_LOADING,
  SUBMITTING_FORM,
  SAVING_ADDRESS,
  GET_RESTAURANT_MENU_FAIL,
} from "../types/types"
import { store } from "../../store"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { getFormattedAPIEndPoint } from "../../utils/urlFormations"
import _ from "../../utils/lodashUtils"
import { FirebaseService, FIREBASE_STATE_KEYS } from "../../firebase"

// Load the restaurants
export const getRestaurants = props => async dispatch => {
  try {
    dispatch({
      type: GETTING_RESTAURANTS,
    })
    const res = await API.get(ENDPOINTS.GET_RESTAURANTS_ENDPOINT)
    dispatch({
      type: GET_RESTAURANTS,
      payload: res.data,
    })
    dispatch({
      type: RESTAURANTS_LOADED,
    })
    if (props.onSuccess) {
      props.onSuccess()
    }
    await FirebaseService.patch({ [FIREBASE_STATE_KEYS.RESTAURANTS]: res.data })
  } catch (err) {
    console.error("getting restaurants error", err.response)
  }
}

// Suggest a restaurant name
export const suggestRestaurant = restaurantName => {
  return {
    type: SUGGEST_RESTAURANT_NAME,
    payload: restaurantName.data.restaurantName,
  }
}

// Accept a restaurant name
export const acceptSuggestion = () => {
  return {
    type: ACCEPT_SUGGESTION,
  }
}

// Decline a restaurant name
export const declineSuggestion = () => {
  return {
    type: DECLINE_SUGGESTION,
  }
}

// Change restaurant
export const changeRestaurant = () => {
  return {
    type: CHANGE_RESTAURANT,
  }
}
// Display popup for Add item to cart.
export const toggleAddToCartItem = (
  showPopup,
  item,
  isUpdate = false
) => async dispatch => {
  if (showPopup == false) {
    dispatch({
      type: SET_LOADER,
      payload: null,
    })
  }
  dispatch({
    type: TOGGLE_ADD_TO_CART_POPUP,
    payload: {
      showPopup,
      item,
      isUpdate,
    },
  })
}
export const setReadyModal = showPopup => async dispatch => {
  dispatch({
    type: SHOW_READY_MODAL,
    payload: showPopup,
  })
}

const getItemOptions = (option_qty, item) => {
  if (_.get(item, "options") === undefined) {
    option_qty[item.id] = item.quantity
    return
  } else {
    if (item.type === "option") {
      option_qty[item.id] = item.quantity
    }
    for (let i in item.options) {
      getItemOptions(option_qty, item.options[i])
    }
  }
}

export const combineOrders = (
  restaurantId,
  userCart,
  partnerCart
) => async () => {
  // Clear Items from Combined Order Cart
  const reqBody = {
    restaurant_id: restaurantId,
    combined_order: true,
  }
  const res = await API.post(ENDPOINTS.EMPTY_CART_ENDPOINT, reqBody)
  // Add Items to Combined Order Cart
  const user = _.get(store.getState(), "auth.user", {})
  const cartList = [
    ...Object.values(userCart || {}),
    ...Object.values(partnerCart || {}),
  ]
  for (let item of cartList) {
    let option_qty = {}
    getItemOptions(option_qty, item)
    const reqBody = {
      restaurant_id: restaurantId,
      item: {
        item_id: item.id,
        item_qty: item.quantity,
        option_qty: option_qty,
        instructions: item.instructions,
        item_label: "",
      },
      combined_order: true,
    }
    try {
      const res = await API.post(ENDPOINTS.ADD_ITEMS_TO_CART_ENDPOINT, reqBody)
    } catch (error) {
      console.error("combine Orders error", error)
    }
  }
}

export const removePartnerOrders = (partnerCart, myCart) => async () => {
  const user = _.get(store.getState(), "auth.user", {})
  partnerCart.forEach(async item => {
    try {
      const itemToRemove = myCart.find(
        cartItem =>
          cartItem.id === item.reqBody.item.item_id &&
          cartItem.quantity === item.reqBody.item.item_qty
      )
      const reqBody = {
        cart_index: itemToRemove.item_key,
        restaurant_id: item.reqBody.restaurant_id,
      }
      const res = await API.post(
        ENDPOINTS.REMOVE_ITEM_FROM_CART_ENDPOINT,
        reqBody
      )
      const deliveryDotComCart = res.data
      user &&
        (await FirebaseService.patch(
          deliveryDotComCart,
          `${FirebaseService.getDefaultPath()}${user.uuid}/${
            FIREBASE_STATE_KEYS.DELIVERY_COM_CART
          }`
        ))
    } catch (error) {
      console.error("remove partner order error", error)
    }
  })
}

// Add or Remove the items from the cart.
export const addOrRemoveItem = (
  item,
  restaurantId,
  updateFirebaseData,
  onSuccess
) => async dispatch => {
  const user = _.get(store.getState(), "auth.user", {})
  const reqBody = {
    restaurant_id: restaurantId,
    item: item.payload,
  }
  dispatch({
    type: SET_LOADER,
    payload: item.payload,
  })
  try {
    const res = await API.post(
      ENDPOINTS.ADD_ITEMS_TO_CART_ENDPOINT,
      reqBody,
      {},
      true
    )

    const deliveryDotComCart = res.data
    const itemToRemove = deliveryDotComCart.cart.find(
      cartItem => cartItem.id === item.payload.item_id
    )
    dispatch({
      type: ADD_OR_REMOVE_ITEM,
      payload: {
        value: item.payload,
        operation: item.operation,
        quantity: item.payload.item_qty,
        deliveryDotComCart,
      },
    })
    dispatch({
      type: REMOVE_ITEM_FROM_SUGGESTED_LIST,
      payload: itemToRemove,
    })

    const userCartPath = `${user.uuid}/${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`
    updateFirebaseData[userCartPath] = deliveryDotComCart

    const userCartListPath = `${user.uuid}/cartList`
    const cart = await FirebaseService.addRemoveItem(
      { item_key: itemToRemove.item_key, reqBody },
      true,
      false
    )
    updateFirebaseData[userCartListPath] = cart
    await FirebaseService.patch(
      updateFirebaseData,
      FirebaseService.getDefaultPath()
    )
    ToastMessage({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: SUCCESS_ITEM_ADD_TO_CART,
    })
    if (onSuccess) {
      onSuccess()
    }
  } catch (err) {
    const errorMessage = _.get(err, "response.data.delivery_error", [])

    dispatch({
      type: REMOVE_ITEM_FROM_CART,
      payload: item.payload,
    })

    if (
      errorMessage &&
      Array.isArray(errorMessage) &&
      errorMessage.length > 0
    ) {
      const idSplit = item.payload.item_id.split("-")
      const id = idSplit[idSplit.length - 1]
      const failedItem = _.get(err, "response.data.error") + ": " + errorMessage
      ToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: failedItem ? failedItem : ERROR_SOMETHING_WENT_WRONG,
      })
    } else {
      // ToastMessage({
      //   type: NOTIFICATION_TYPES.ERROR,
      //   message: ERROR_SOMETHING_WENT_WRONG,
      // })
    }
  }
  dispatch({
    type: SET_LOADER,
    payload: null,
  })
}

export const removeItemFromCart = (
  item,
  restaurantId,
  key = -1
) => async dispatch => {
  const deliveryDotComCartt = store.getState().planDinner.deliveryDotComCart
  const user = _.get(store.getState(), "auth.user", {})
  dispatch({
    type: SET_LOADER,
    payload: { ...item, item_id: item.id },
  })
  const itemList = deliveryDotComCartt.cart.filter(
    cartItem => cartItem.id === item.id
  )
  const itemToBeDeleted = itemList[itemList.length - 1]
  const reqBody = {
    cart_index: key !== -1 ? key : itemToBeDeleted.item_key,
    restaurant_id: restaurantId,
  }
  try {
    const res = await API.post(
      ENDPOINTS.REMOVE_ITEM_FROM_CART_ENDPOINT,
      reqBody
    )
    const deliveryDotComCart = res.data
    dispatch({
      type: REMOVE_ITEM_FROM_CART,
      payload: {
        itemName: item.name,
        deliveryDotComCart,
      },
    })
    ToastMessage({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: SUCCESS_ITEM_REMOVE_FROM_CART,
    })
    user &&
      (await FirebaseService.patch(
        deliveryDotComCart,
        `${FirebaseService.getDefaultPath()}${user.uuid}/${
          FIREBASE_STATE_KEYS.DELIVERY_COM_CART
        }`
      ))
    user && (await FirebaseService.addRemoveItem(itemToBeDeleted, false))
    dispatch({
      type: SET_LOADER,
      payload: null,
    })
  } catch (error) {
    dispatch({
      type: SET_LOADER,
      payload: null,
    })
    console.log(error)
  }
}
export const addSelectedItemOptions = data => async dispatch => {
  dispatch({
    type: SELECTED_ITEM_OPTIONS,
    payload: data,
  })
}

export const emptyDeliveryDotComCart = (
  restaurantId,
  showcartPopUp = true,
  isCombined,
  isPayingBoth,
  updateFirebase = true
) => async dispatch => {
  const user = _.get(store.getState(), "auth.user", {})
  const partner = _.get(store.getState(), "auth.partner", {})
  const userId = _.get(user, "uuid")
  const partnerId = _.get(partner, "uuid")
  const path = `${FirebaseService.getDefaultPath()}${userId}/cartList`
  const partnerPath = `${FirebaseService.getDefaultPath()}${partnerId}/cartList`
  const reqBody = {
    restaurant_id: restaurantId,
  }
  user &&
    updateFirebase &&
    (await FirebaseService.write(
      null,
      `${FirebaseService.getDefaultPath()}${user.uuid}/${
        FIREBASE_STATE_KEYS.DELIVERY_COM_CART
      }`
    ))
  user && updateFirebase && (await FirebaseService.delete(path))
  if (isCombined || isPayingBoth) {
    reqBody["clear_partner"] = true
    partner &&
      updateFirebase &&
      (await FirebaseService.write(
        null,
        `${FirebaseService.getDefaultPath()}${partner.uuid}/${
          FIREBASE_STATE_KEYS.DELIVERY_COM_CART
        }`
      ))
    partner && (await FirebaseService.delete(partnerPath))
  }
  const res = await API.post(ENDPOINTS.EMPTY_CART_ENDPOINT, reqBody)
  const deliveryDotComCart = res.data
  dispatch({
    type: EMPTY_DELIVERY_DOT_COM_CART,
    payload: {
      deliveryDotComCart,
    },
  })
  if (showcartPopUp) {
    ToastMessage({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: SUCCESS_CART_CLEAR,
    })
  }
}
export const setLoadingMenus = value => async dispatch => {
  dispatch({
    type: SET_LOADING_MENUS,
    payload: value,
  })
}
export const setSuggestion = value => async dispatch => {
  dispatch({
    type: SET_SUGGESTING,
    payload: value,
  })
}
export const setPartnerOperation = value => async dispatch => {
  dispatch({
    type: PARTNER_OPERATION_LOADING,
    payload: value,
  })
}
export const setSubmitting = value => async dispatch => {
  dispatch({
    type: SUBMITTING_FORM,
    payload: value,
  })
}

// Retrieves the Menu for a restaurant
export const getRestaurantMenu = restaurantId => async dispatch => {
  try {
    const url = getFormattedAPIEndPoint(ENDPOINTS.GET_RESTAURANT_MENU, {
      $restaurantId: restaurantId,
    })
    const res = await API.get(url)
    const menus = {}
    for (let _menu of _.get(res, "data.menu", [])) {
      if (_.get(_menu, "type") === "menu") {
        if (_.get(_menu, "children.0.type") === "menu") {
          for (let _submenu of _.get(_menu, "children", [])) {
            if (_.get(_submenu, "children.0.type") === "menu") {
              for (let _menuList of _.get(_submenu, "children", [])) {
                const category = _.get(_menuList, "id")
                if (category != undefined) {
                  menus[category] = {
                    name: _menuList.name,
                    children: _menuList.children,
                  }
                }
              }
            } else {
              const category = _.get(_submenu, "id")
              if (category != undefined) {
                menus[category] = {
                  name: _submenu.name,
                  children: _submenu.children,
                }
              }
            }
          }
        } else {
          const category = _.get(_menu, "id")
          if (category != undefined) {
            menus[category] = {
              name: _menu.name,
              children: _menu.children,
            }
          }
        }
      }
    }
    dispatch({
      type: GET_RESTAURANT_MENU,
      payload: {
        menus,
        restDisclaimerText:
          res.data.disclaimers.special_instructions_disclaimer,
      },
    })
    await FirebaseService.patch(
      {
        menus,
        restDisclaimerText:
          res.data.disclaimers.special_instructions_disclaimer,
      },
      `${FirebaseService.getDefaultPath()}/${
        FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT
      }`
    )
  } catch (err) {
    dispatch({
      type: GET_RESTAURANT_MENU_FAIL,
    })
  }
}

export const whichItemAreSuggested = payload => {
  return {
    type: WHICH_ITEMS_ARE_SUGGESTED,
    payload,
  }
}
export const resetWhichItemsAreSuggested = () => {
  return {
    type: RESET_WHICH_ITEMS_ARE_SUGGESTED,
  }
}

export const removeItemFromSuggestedItemsList = item => {
  return {
    type: REMOVE_ITEM_FROM_SUGGESTED_LIST,
    payload: item,
  }
}

// Gets the cart details from Delivery.com
export const getTheCartFromDelivery = restaurantId => async dispatch => {
  const user = _.get(store.getState(), "auth.user", {})
  const URL = getFormattedAPIEndPoint(ENDPOINTS.GET_CART_ENDPOINT, {
    $restaurantId: restaurantId,
  })

  try {
    const res = await API.get(URL)

    const deliveryDotComCart = res.data
    const itemsInCart = {}
    deliveryDotComCart.cart.forEach(item => {
      itemsInCart[item.id] = { quantity: item.quantity }
    })
    dispatch({
      type: GET_CART_ITEMS_FROM_DELIVERY,
      payload: {
        itemsInCart,
        deliveryDotComCart,
      },
    })
    user &&
      (await FirebaseService.write(
        deliveryDotComCart,
        `${FirebaseService.getDefaultPath()}${user.uuid}/${
          FIREBASE_STATE_KEYS.DELIVERY_COM_CART
        }`
      ))
  } catch (err) {
    console.error(err)
  }
}

export const computeCartStatus = () => {
  const cartItems = _.get(
    store.getState(),
    "planDinner.deliveryDotComCart.cart",
    []
  )
  const totalAmount = _.get(
    store.getState(),
    "planDinner.deliveryDotComCart.total",
    0
  )
  return { cartItems, total: totalAmount }
}

export const getWhichItemsAreSuggested = () => {
  const state = store.getState()
  const whichItemAreSuggested = _.get(
    state,
    "planDinner.whichItemAreSuggested",
    {}
  )
  return whichItemAreSuggested
}

export const notifyWhenRestaurantsOpen = () => async dispatch => {
  const reqBody = {
    action: "ANY_RESTAURANT_OPEN",
  }
  try {
    const res = await API.post(ENDPOINTS.SUBSCRIBE_TO_NOTIFY, reqBody)
    FirebaseService.write(
      true,
      `${FirebaseService.getDefaultPath()}notifyRestaurants`
    )
    dispatch({
      type: NOTIFY_SUBSCRIBED,
      payload: res.data,
    })
  } catch (error) {
    console.error("notify when restaurants open error", error)
  }
}

export const restaurantWishList = ({ restaurantName }) => async dispatch => {
  const reqBody = {
    restaurant_list: [restaurantName.trim()],
  }
  try {
    const res = await API.post(ENDPOINTS.SAVE_RESTAURANT_SUGGESTION, reqBody)
    return res
  } catch (error) {
    console.error("restaurant wish list error", error)
  }
}

export const checkCommonRestaurantsForUs = (
  address,
  partnerAddress
) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.CHECK_COMMON_RESTAURANTS, {
    $address: address,
    $partner_address: partnerAddress,
  })

  try {
    const res = await API.get(URL)
    return res.data
  } catch (error) {}
}

export const saveSuggestionEvent = (
  {
    suggestedBy,
    suggestedTo,
    type,
    id,
    menu,
    isAccepted,
    partner1Location,
    partner2Location,
    date,
  },
  onSuccess
) => async dispatch => {
  const reqBody = {
    suggested_by: suggestedBy,
    suggested_to: suggestedTo,
    suggestion_type: type,
    restaurant_id: id,
    menu_item: menu,
    accepted: isAccepted,
    partner1_location: partner1Location,
    partner2_location: partner2Location,
    date_time: date,
  }
  try {
    const res = await API.post(ENDPOINTS.SAVE_SUGGESTION_EVENT, reqBody)
    if (onSuccess) {
      onSuccess()
    }
  } catch (error) {
    console.error("save suggestion", error)
  }
}

export const saveInstructionsToItem = reqPayload => async dispatch => {
  try {
    dispatch({
      type: SET_LOADER,
      payload: reqPayload.item,
    })
    const res = await API.put(ENDPOINTS.UPDATE_MENU_ITEM, reqPayload, {}, true)
    const user = _.get(store.getState(), "auth.user", {})
    const deliveryDotComCart = res.data
    const itemsInCart = {}
    deliveryDotComCart.cart.forEach(item => {
      itemsInCart[item.id] = { quantity: item.quantity }
    })
    user &&
      (await FirebaseService.patch(
        deliveryDotComCart,
        `${FirebaseService.getDefaultPath()}${user.uuid}/${
          FIREBASE_STATE_KEYS.DELIVERY_COM_CART
        }`
      ))
    dispatch({
      type: GET_CART_ITEMS_FROM_DELIVERY,
      payload: {
        itemsInCart,
        deliveryDotComCart,
      },
    })
    dispatch({
      type: TOGGLE_ADD_TO_CART_POPUP,
      payload: {
        showPopup: false,
      },
    })
  } catch (err) {
    const errorMessage = _.get(err, "response.data.delivery_error", [])
    if (
      errorMessage &&
      Array.isArray(errorMessage) &&
      errorMessage.length > 0
    ) {
      const failedItem = _.get(err, "response.data.error") + ": " + errorMessage
      ToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: failedItem ? failedItem : ERROR_SOMETHING_WENT_WRONG,
      })
    }
  }

  dispatch({
    type: SET_LOADER,
    payload: null,
  })
}

export const validateUserAddress = (
  address,
  restaurantId,
  updateOnValidAddress
) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.VALIDATE_ADDRESS, {
    $address: address,
    $restaurantId: restaurantId,
  })
  try {
    const res = await API.get(URL, {}, restaurantId ? false : true)
    //if address valid, accept restaurant suggestion and perform firebase activities
    if (updateOnValidAddress) updateOnValidAddress()()
    dispatch({
      type: SAVING_ADDRESS,
      payload: false,
    })
  } catch (err) {
    dispatch({
      type: SAVING_ADDRESS,
      payload: false,
    })
    return err.response
  }
}
